import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { TitleSm } from "../design/Title";

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFSwitch({
  name,
  label,
  labelPlacement,
  helperText,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <FormControlLabel
            labelPlacement={labelPlacement}
            label={<TitleSm>{label}</TitleSm>}
            control={<Switch {...field} checked={field.value} />}
            {...other}
          />

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>
              {error ? error?.message : helperText}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
